import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { MsalService } from '@azure/msal-angular';
import { AuthService } from './auth.service.service';
@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {
  constructor(public auth: AuthService, public router: Router, private authService: MsalService) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // if (!this.authService.getAccount()) {
    //   this.router.navigate(['/']);
    //   return false;
    // }
    // return true;
    const account = this.authService.getAccount();
    const requiredRoles = ['NGTW_POUser', 'RMPM_Admin', 'RMPM_User', 'RMPM_User_QA', 'NGTW_POUser_QA']; // Get roles for this route
    /* istanbul ignore next */
    if (account && account.idTokenClaims) {
      const userRoles = account.idTokenClaims['roles'] || [];
      const hasRole = requiredRoles.some(role => userRoles.includes(role));

      if (hasRole) {
        return true;
      } else {
        this.router.navigate(['/no-privilage']);
        return false;
      }
    }

    // Redirect to login or another route if not authenticated
    this.router.navigate(['/']);
    return false;
  }



  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
